import { render } from "./BrochureTable.vue?vue&type=template&id=bac80fca"
import script from "./BrochureTable.vue?vue&type=script&lang=js"
export * from "./BrochureTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__